export default "__VITE_PUBLIC_ASSET__bc2f285c__"